var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.rootClass,attrs:{"src":_vm.src,"alt":_vm.alt,"loading":_vm.lazy ? 'lazy' : 'eager',"decoding":"async"},on:{"load":_vm.onLoaded,"error":_vm.onLoaded}})}
var staticRenderFns = []

export { render, staticRenderFns }